// removed by extract-text-webpack-plugin
module.exports = {"form":"_3SzyqBPpOXyHc6e7NaH3TF"};


//////////////////
// WEBPACK FOOTER
// ./src/uis/components/Form/Form.css
// module id = 1317
// module chunks = 0